import React, { useEffect } from "react"
import { BiTime } from "react-icons/bi"

interface DeliverySlot {
  from: string
  to: string
  label: string
  deliveryType: string
}

interface DeliverySlotsProps {
  slots: DeliverySlot[]
  selectedSlot: any //DeliverySlot | null
  onSlotSelect: (slot: DeliverySlot) => void
  deliveryType: string 
}

const DeliverySlots: React.FC<DeliverySlotsProps> = ({ slots, selectedSlot, onSlotSelect, deliveryType }) => {
  const [currentSlots, setCurrentSlots] = React.useState<DeliverySlot[]>([])
  
  const formatTimeRange = (from: string, to: string) => {
    return `${from} - ${to}`
  }

  useEffect(() => {
    // Filter slots that match the current delivery type
    const filteredSlots = slots.filter(slot => slot?.deliveryType === deliveryType)
    setCurrentSlots(filteredSlots)
  }, [slots, deliveryType])

  return (
    <div className="space-y-3">
      {currentSlots.map((slot, index) => (
        <div
          key={`${slot.label}-${slot.from}-${slot.to}-${index}`}
          onClick={() => onSlotSelect(slot)}
          className={`
            flex items-center p-4 border-2 rounded-lg cursor-pointer transition-all
            ${
              selectedSlot?.label === slot.label && selectedSlot?.from === slot.from && selectedSlot?.to === slot.to
                ? "border-blue-500 bg-blue-50"
                : "border-gray-200 hover:border-gray-300"
            }
          `}
        >
          <div
            className={`
              flex-shrink-0 p-2 rounded-full mr-4
              ${selectedSlot?.label === slot.label && selectedSlot?.from === slot.from && selectedSlot?.to === slot.to 
                ? "bg-blue-100 text-blue-600" 
                : "bg-gray-100 text-gray-600"}
            `}
          >
            <BiTime size={20} />
          </div>

          <div className="flex-grow">
            <h4 className={`font-medium ${
              selectedSlot?.label === slot.label && selectedSlot?.from === slot.from && selectedSlot?.to === slot.to 
                ? "text-blue-700" 
                : "text-gray-800"
            }`}>
              {slot.label}
            </h4>
            <p className="text-sm text-gray-500">{formatTimeRange(slot.from, slot.to)}</p>
          </div>

          <div className="flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center">
            {selectedSlot?.label === slot.label && selectedSlot?.from === slot.from && selectedSlot?.to === slot.to && (
              <div className="w-3 h-3 rounded-full bg-blue-500"></div>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

export default DeliverySlots